import { render, staticRenderFns } from "./LOAExplainedThroughAPersonalCheck.vue?vue&type=template&id=98ab877a&scoped=true&"
import script from "./LOAExplainedThroughAPersonalCheck.vue?vue&type=script&lang=js&"
export * from "./LOAExplainedThroughAPersonalCheck.vue?vue&type=script&lang=js&"
import style0 from "./LOAExplainedThroughAPersonalCheck.vue?vue&type=style&index=0&id=98ab877a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ab877a",
  null
  
)

export default component.exports